import { gsap } from "gsap";
import NavHeight from "../utils/nav-height";
import { lenis } from '../libs/scrollLenis';

export default class NavResponsive {
    constructor() {
        const navHeight = new NavHeight();
        this.navHeightValue = navHeight.navHeightValue;

        this.navResponsive = document.querySelector(".nav-responsive");
        this.navMenu       = document.querySelector(".nav-menu");
        this.navBurgers    = document.querySelectorAll(".burger");
        this.navOverlay = document.querySelector(".nav-overlay");
        if (!this.navOverlay) {
            this.navOverlay = document.createElement("div");
            this.navOverlay.className = "nav-overlay";
            document.body.appendChild(this.navOverlay);
        }
        this.navOverlay.addEventListener("click", () => this.closeResponsive());

        this.init();
        this.bindResponsiveScroll();
        this.observeResponsiveState();
    }

    observeResponsiveState() {
        if (!this.navResponsive || !this.navMenu) return;

        const syncClass = () => {
            const active = this.navResponsive.classList.contains("active");
            this.navMenu.classList.toggle("nav-responsive-active", active);
            this.navOverlay?.classList.toggle("active", active);
        };

        this._mo = new MutationObserver(syncClass);
        this._mo.observe(this.navResponsive, { attributes: true, attributeFilter: ["class"] });
        syncClass();
    }

    init() {
        this.initNavBurger();
        this.initResponsiveSubMenus();
    }

    // === BURGER ===
    initNavBurger() {
        if (!this.navBurgers.length || !this.navResponsive) return;

        this.navBurgers.forEach(burger => {
            burger.addEventListener("click", () => {
                const isOpen = this.navResponsive.classList.contains("active");
                this.navBurgers.forEach(b => b.classList.toggle("active", !isOpen));
                isOpen ? this.closeResponsive() : this.openResponsive();
            });
        });
    }

    openResponsive() {
        this.navResponsive.classList.add("active");
        gsap.fromTo(this.navResponsive,
            { y: `-${this.navHeightValue}px`, opacity: 0 },
            {
                y: 0, opacity: 1, duration: 0.5, ease: "power2.inOut",
                onStart: () => {
                    document.body.classList.add("overflow-hidden");
                    this.navOverlay?.classList.add("active");
                    gsap.to(this.navOverlay, { opacity: 1, duration: 0.3, overwrite: "auto" });
                }
            }
        );
        window.dispatchEvent(new CustomEvent("nav:responsive:open"));
    }

    closeResponsive() {
        gsap.to(this.navOverlay, {
            opacity: 0, duration: 0.3, overwrite: "auto",
            onComplete: () => this.navOverlay?.classList.remove("active")
        });
        gsap.to(this.navResponsive, {
            y: `-${this.navHeightValue}px`, opacity: 0, duration: 0.5, ease: "power2.inOut",
            onComplete: () => {
                this.navResponsive.classList.remove("active");
                document.body.classList.remove("overflow-hidden");
                this.resetMenu();
                window.dispatchEvent(new CustomEvent("nav:responsive:close"));
            }
        });
    }

    bindResponsiveScroll() {
        const content = document.querySelector('.nav-responsive_content');
        if (!content) return;

        content.setAttribute('data-lenis-prevent', '');

        content.addEventListener('mousedown', () => { lenis?.stop(); });
        content.addEventListener('mouseup',   () => { lenis?.start(); });

        content.addEventListener('touchstart', () => { lenis?.stop(); });
        content.addEventListener('touchend',   () => { lenis?.start(); });
    }

    // === RESPONSIVE SUB MENU WITH PANELS ===
    initResponsiveSubMenus() {
        if (window.innerWidth >= 1200) return;

        const menuContainer = document.querySelector(".nav-responsive ul.menu-responsive");
        if (!menuContainer) return;

        document.querySelectorAll(".nav-responsive ul.menu-responsive > li.menu-responsive_item-has-children > a").forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const parentLi = this.closest("li.menu-responsive_item-has-children");
                const megaMenu = parentLi.querySelector(".megamenu-responsive");
                if (!megaMenu) return;

                megaMenu.classList.add("active");
                gsap.fromTo(megaMenu, { x: "100%", opacity: 0 }, { x: "0%", opacity: 1, duration: 0.5, ease: "power2.inOut" });
            });
        });

        document.querySelectorAll(".megamenu-responsive .sub-menu.level-0 > li.sub-menu_item-has-children > a").forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const parentLi = this.closest("li.sub-menu_item-has-children");
                const subMenuLevel1 = parentLi.querySelector(".sub-menu.level-1");
                if (!subMenuLevel1) return;

                subMenuLevel1.classList.add("active");
                gsap.fromTo(subMenuLevel1, { x: "100%", opacity: 0 }, { x: "0%", opacity: 1, duration: 0.5, ease: "power2.inOut" });
            });
        });

        document.querySelectorAll(".submenu-back").forEach(backButton => {
            backButton.addEventListener("click", function (e) {
                e.preventDefault();
                const parentMenu = this.closest(".megamenu-responsive, .sub-menu.level-1");
                if (!parentMenu) return;

                gsap.to(parentMenu, {
                    x: "100%", opacity: 0, duration: 0.5, ease: "power2.inOut",
                    onComplete: () => parentMenu.classList.remove("active")
                });
            });
        });
    }

    // === RESET MENU ===
    resetMenu() {
        const activeMenus = document.querySelectorAll(".megamenu-responsive.active, .sub-menu.level-1.active");
        activeMenus.forEach(menu => {
            gsap.to(menu, {
                x: "100%", opacity: 0, duration: 0.5, ease: "power2.inOut",
                onComplete: () => menu.classList.remove("active")
            });
        });
    }
}
